var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceBlueprint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 122,
    viewBox: "0 0 300 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.89 120H0.11C0.05 120 0 119.95 0 119.89V4C0 1.79 1.79 0 4 0H295.89C298.16 0 300 1.84 300 4.11V119.89C300 119.95 299.95 120 299.89 120Z",
    fill: "url(#paint0_linear_223_28220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 39.99H35.7999C33.7899 39.99 32.1599 38.43 32.1599 36.51C32.1599 34.59 33.7899 33.02 35.7999 33.02H98.1899C100.2 33.02 101.83 34.58 101.83 36.51C101.83 38.44 100.2 39.99 98.1899 39.99Z",
    fill: "url(#paint1_linear_223_28220)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_223_28220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 8.54C299.78 8.51 299.55 8.5 299.32 8.5H13.18C10.05 8.5 7.5 10.94 7.5 13.94V120H8.54V13.94C8.54 11.49 10.62 9.5 13.18 9.5H299.31C299.54 9.5 299.77 9.53 299.99 9.57V8.55L300 8.54Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.7 39.9798H123.31C121.3 39.9798 119.67 38.4198 119.67 36.4998C119.67 34.5798 121.3 33.0098 123.31 33.0098H185.7C187.71 33.0098 189.34 34.5698 189.34 36.4998C189.34 38.4298 187.71 39.9798 185.7 39.9798Z",
    fill: "url(#paint2_linear_223_28220)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.7 39.9798H208.31C206.3 39.9798 204.67 38.4198 204.67 36.4998C204.67 34.5798 206.3 33.0098 208.31 33.0098H270.7C272.71 33.0098 274.34 34.5698 274.34 36.4998C274.34 38.4298 272.71 39.9798 270.7 39.9798Z",
    fill: "url(#paint3_linear_223_28220)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4499 93.99H36.0599C34.0499 93.99 32.4199 92.43 32.4199 90.51C32.4199 88.59 34.0499 87.02 36.0599 87.02H98.4499C100.46 87.02 102.09 88.58 102.09 90.51C102.09 92.44 100.46 93.99 98.4499 93.99Z",
    fill: "url(#paint4_linear_223_28220)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.95 93.9798H123.56C121.55 93.9798 119.92 92.4198 119.92 90.4998C119.92 88.5798 121.55 87.0098 123.56 87.0098H185.95C187.96 87.0098 189.59 88.5698 189.59 90.4998C189.59 92.4298 187.96 93.9798 185.95 93.9798Z",
    fill: "url(#paint5_linear_223_28220)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.95 93.9798H208.56C206.55 93.9798 204.92 92.4198 204.92 90.4998C204.92 88.5798 206.55 87.0098 208.56 87.0098H270.95C272.96 87.0098 274.59 88.5698 274.59 90.4998C274.59 92.4298 272.96 93.9798 270.95 93.9798Z",
    fill: "url(#paint6_linear_223_28220)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4499 105.99H36.0599C34.0499 105.99 32.4199 104.43 32.4199 102.51C32.4199 100.59 34.0499 99.02 36.0599 99.02H98.4499C100.46 99.02 102.09 100.58 102.09 102.51C102.09 104.44 100.46 105.99 98.4499 105.99Z",
    fill: "url(#paint7_linear_223_28220)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.95 105.98H123.56C121.55 105.98 119.92 104.42 119.92 102.5C119.92 100.58 121.55 99.0098 123.56 99.0098H185.95C187.96 99.0098 189.59 100.57 189.59 102.5C189.59 104.43 187.96 105.98 185.95 105.98Z",
    fill: "url(#paint8_linear_223_28220)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.95 105.98H208.56C206.55 105.98 204.92 104.42 204.92 102.5C204.92 100.58 206.55 99.0098 208.56 99.0098H270.95C272.96 99.0098 274.59 100.57 274.59 102.5C274.59 104.43 272.96 105.98 270.95 105.98Z",
    fill: "url(#paint9_linear_223_28220)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M173.14 65.5C173.14 63.61 174.62 62.12 176.52 62.12C178.42 62.12 179.9 63.6 179.9 65.5C179.9 67.4 178.39 68.88 176.52 68.88C174.65 68.88 173.14 67.37 173.14 65.5ZM176.52 63.81C175.59 63.81 174.83 64.57 174.83 65.5C174.83 66.43 175.59 67.19 176.52 67.19C177.45 67.19 178.21 66.43 178.21 65.5C178.21 64.57 177.45 63.81 176.52 63.81ZM177.82 56.5C178.6 56.5 179.28 57.03 179.46 57.79L179.73 58.93C180.03 59.08 180.31 59.24 180.58 59.42L181.71 59.09C182.46 58.87 183.26 59.19 183.65 59.86L184.95 62.12C185.34 62.79 185.21 63.65 184.65 64.19L183.8 64.97C183.81 65.16 183.82 65.33 183.82 65.49C183.82 65.65 183.82 65.82 183.8 65.98L184.65 66.79C185.21 67.33 185.34 68.18 184.95 68.86L183.65 71.12C183.26 71.79 182.46 72.11 181.71 71.9L180.58 71.57C180.31 71.75 180.02 71.92 179.73 72.07L179.46 73.21C179.28 73.97 178.6 74.5 177.82 74.5H175.21C174.43 74.5 173.75 73.97 173.57 73.21L173.3 72.07C173 71.92 172.72 71.76 172.45 71.57L171.29 71.9C170.57 72.12 169.77 71.8 169.38 71.12L168.08 68.86C167.69 68.19 167.81 67.33 168.38 66.79L169.23 65.98C169.22 65.82 169.21 65.65 169.21 65.46C169.21 65.33 169.21 65.16 169.23 64.97L168.38 64.19C167.82 63.65 167.69 62.8 168.08 62.12L169.38 59.86C169.77 59.18 170.57 58.86 171.29 59.09L172.45 59.42C172.72 59.24 173.01 59.07 173.3 58.93L173.57 57.79C173.75 57.03 174.43 56.5 175.21 56.5H177.82ZM174.74 60.14L174.35 60.31C173.9 60.5 173.49 60.74 173.11 61.03L172.77 61.29L170.84 60.72L169.54 62.98L171 64.37L170.95 64.79C170.92 65.03 170.91 65.26 170.91 65.51C170.91 65.76 170.93 65.99 170.95 66.23L171 66.65L169.54 68.04L170.84 70.3L172.77 69.73L173.11 69.99C173.49 70.28 173.9 70.52 174.35 70.71L174.74 70.88L175.21 72.83H177.82L178.29 70.88L178.68 70.71C179.13 70.52 179.54 70.28 179.92 69.99L180.26 69.73L182.19 70.3L183.49 68.04L182.03 66.65L182.08 66.23C182.11 65.99 182.13 65.76 182.13 65.51C182.13 65.26 182.12 65.03 182.08 64.79L182.03 64.37L183.49 62.98L182.19 60.72L180.26 61.29L179.92 61.03C179.54 60.74 179.13 60.5 178.68 60.31L178.29 60.14L177.82 58.19H175.21L174.74 60.14Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M162.38 73.1L157.67 68.39C158.69 67.14 159.25 65.57 159.25 63.85C159.25 59.81 155.98 56.54 151.94 56.54C147.9 56.54 144.66 59.81 144.66 63.85C144.66 67.89 147.93 71.16 151.94 71.16C153.66 71.16 155.23 70.57 156.48 69.58L161.19 74.29C161.39 74.46 161.6 74.54 161.82 74.54C162.04 74.54 162.25 74.46 162.42 74.29C162.75 73.96 162.75 73.43 162.39 73.1H162.38ZM146.35 63.85C146.35 60.75 148.87 58.23 151.97 58.23C155.07 58.23 157.59 60.75 157.59 63.85C157.59 66.95 155.07 69.47 151.97 69.47C148.87 69.47 146.35 66.95 146.35 63.85Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M127.95 72.18C127.95 72.4 128.01 72.62 128.14 72.8L128.74 73.7C128.92 73.98 129.34 74.2 129.68 74.2H131.85C132.18 74.2 132.6 73.97 132.79 73.7L133.39 72.8C133.49 72.64 133.58 72.37 133.58 72.18V70.8H127.96V72.18H127.95ZM130.76 56.21C127.17 56.22 124.57 59.13 124.57 62.37C124.57 63.93 125.15 65.35 126.1 66.44C126.68 67.1 127.59 68.49 127.94 69.66C127.94 69.66 127.94 69.68 127.94 69.69H133.57C133.57 69.69 133.57 69.67 133.57 69.66C133.92 68.49 134.82 67.11 135.41 66.44C136.36 65.38 136.94 63.96 136.94 62.37C136.94 58.98 134.17 56.21 130.75 56.21H130.76ZM134.15 65.35C133.6 65.98 132.92 66.98 132.43 68.02H129.1C128.61 66.98 127.93 65.98 127.38 65.35C126.66 64.53 126.27 63.45 126.27 62.36C126.27 60.19 127.96 57.9 130.74 57.89C133.25 57.89 135.27 59.91 135.27 62.36C135.27 63.45 134.88 64.53 134.16 65.35H134.15ZM130.2 59.02C128.65 59.02 127.39 60.28 127.39 61.83C127.39 62.14 127.64 62.39 127.95 62.39C128.26 62.39 128.51 62.14 128.51 61.83C128.51 60.9 129.27 60.14 130.2 60.14C130.51 60.14 130.76 59.89 130.76 59.58C130.76 59.27 130.51 59.02 130.2 59.02Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M241.28 71.6199C241.28 71.8399 241.34 72.0599 241.47 72.2399L242.07 73.1399C242.25 73.4199 242.67 73.6399 243.01 73.6399H245.18C245.51 73.6399 245.93 73.4099 246.12 73.1399L246.72 72.2399C246.82 72.0799 246.91 71.8099 246.91 71.6199V70.2399H241.29V71.6199H241.28ZM244.09 55.6499C240.5 55.6599 237.9 58.5699 237.9 61.8099C237.9 63.3699 238.48 64.7899 239.43 65.8799C240.01 66.5399 240.92 67.9299 241.27 69.0999C241.27 69.0999 241.27 69.1199 241.27 69.1299H246.9C246.9 69.1299 246.9 69.1099 246.9 69.0999C247.25 67.9299 248.15 66.5499 248.74 65.8799C249.69 64.8199 250.27 63.3999 250.27 61.8099C250.27 58.4199 247.5 55.6499 244.08 55.6499H244.09ZM247.48 64.7899C246.93 65.4199 246.25 66.4199 245.76 67.4599H242.43C241.94 66.4199 241.26 65.4199 240.71 64.7899C239.99 63.9699 239.6 62.8899 239.6 61.7999C239.6 59.6299 241.29 57.3399 244.07 57.3299C246.58 57.3299 248.6 59.3499 248.6 61.7999C248.6 62.8899 248.21 63.9699 247.49 64.7899H247.48ZM243.53 58.4599C241.98 58.4599 240.72 59.7199 240.72 61.2699C240.72 61.5799 240.97 61.8299 241.28 61.8299C241.59 61.8299 241.84 61.5799 241.84 61.2699C241.84 60.3399 242.6 59.5799 243.53 59.5799C243.84 59.5799 244.09 59.3299 244.09 59.0199C244.09 58.7099 243.84 58.4599 243.53 58.4599Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M65.72 64.6499C65.72 62.7599 67.2 61.2699 69.1 61.2699C71 61.2699 72.48 62.7499 72.48 64.6499C72.48 66.5499 70.97 68.0299 69.1 68.0299C67.23 68.0299 65.72 66.5199 65.72 64.6499ZM69.1 62.9599C68.17 62.9599 67.41 63.7199 67.41 64.6499C67.41 65.5799 68.17 66.3399 69.1 66.3399C70.03 66.3399 70.79 65.5799 70.79 64.6499C70.79 63.7199 70.03 62.9599 69.1 62.9599ZM70.4 55.6499C71.18 55.6499 71.86 56.1799 72.04 56.9399L72.31 58.0799C72.61 58.2299 72.89 58.3899 73.16 58.5699L74.29 58.2399C75.04 58.0199 75.84 58.3399 76.23 59.0099L77.53 61.2699C77.92 61.9399 77.79 62.7999 77.23 63.3399L76.38 64.1199C76.39 64.3099 76.4 64.4799 76.4 64.6399C76.4 64.7999 76.4 64.9699 76.38 65.1299L77.23 65.9399C77.79 66.4799 77.92 67.3299 77.53 68.0099L76.23 70.2699C75.84 70.9399 75.04 71.2599 74.29 71.0499L73.16 70.7199C72.89 70.8999 72.6 71.0699 72.31 71.2199L72.04 72.3599C71.86 73.1199 71.18 73.6499 70.4 73.6499H67.79C67.01 73.6499 66.33 73.1199 66.15 72.3599L65.88 71.2199C65.58 71.0699 65.3 70.9099 65.03 70.7199L63.87 71.0499C63.15 71.2699 62.35 70.9499 61.96 70.2699L60.66 68.0099C60.27 67.3399 60.39 66.4799 60.96 65.9399L61.81 65.1299C61.8 64.9699 61.79 64.7999 61.79 64.6099C61.79 64.4799 61.79 64.3099 61.81 64.1199L60.96 63.3399C60.4 62.7999 60.27 61.9499 60.66 61.2699L61.96 59.0099C62.35 58.3299 63.15 58.0099 63.87 58.2399L65.03 58.5699C65.3 58.3899 65.59 58.2199 65.88 58.0799L66.15 56.9399C66.33 56.1799 67.01 55.6499 67.79 55.6499H70.4ZM67.32 59.2899L66.93 59.4599C66.48 59.6499 66.07 59.8899 65.69 60.1799L65.35 60.4399L63.42 59.8699L62.12 62.1299L63.58 63.5199L63.53 63.9399C63.5 64.1799 63.49 64.4099 63.49 64.6599C63.49 64.9099 63.51 65.1399 63.53 65.3799L63.58 65.7999L62.12 67.1899L63.42 69.4499L65.35 68.8799L65.69 69.1399C66.07 69.4299 66.48 69.6699 66.93 69.8599L67.32 70.0299L67.79 71.9799H70.4L70.87 70.0299L71.26 69.8599C71.71 69.6699 72.12 69.4299 72.5 69.1399L72.84 68.8799L74.77 69.4499L76.07 67.1899L74.61 65.7999L74.66 65.3799C74.69 65.1399 74.71 64.9099 74.71 64.6599C74.71 64.4099 74.7 64.1799 74.66 63.9399L74.61 63.5199L76.07 62.1299L74.77 59.8699L72.84 60.4399L72.5 60.1799C72.12 59.8899 71.71 59.6499 71.26 59.4599L70.87 59.2899L70.4 57.3399H67.79L67.32 59.2899Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_28220",
    x: 5.5,
    y: 6.5,
    width: 296.5,
    height: 115.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_28220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_28220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_28220",
    x1: 0,
    y1: 60,
    x2: 300,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#016161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18AEAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_223_28220",
    x1: 32.1699,
    y1: 36.51,
    x2: 101.83,
    y2: 36.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_223_28220",
    x1: 119.67,
    y1: 36.4998,
    x2: 189.33,
    y2: 36.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_223_28220",
    x1: 204.67,
    y1: 36.4998,
    x2: 274.33,
    y2: 36.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_223_28220",
    x1: 32.4199,
    y1: 90.5,
    x2: 102.08,
    y2: 90.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_223_28220",
    x1: 119.92,
    y1: 90.4998,
    x2: 189.58,
    y2: 90.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_223_28220",
    x1: 204.92,
    y1: 90.4998,
    x2: 274.58,
    y2: 90.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_223_28220",
    x1: 32.4199,
    y1: 102.5,
    x2: 102.08,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_223_28220",
    x1: 119.92,
    y1: 102.5,
    x2: 189.58,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_223_28220",
    x1: 204.92,
    y1: 102.5,
    x2: 274.58,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBlueprint);
export default __webpack_public_path__ + "static/media/ServiceBlueprint.f31a2798.svg";
export { ForwardRef as ReactComponent };